import {
  CookieConsent,
  CookieCategory,
  CookieConsentPermissions,
} from '@tribeplatform/react-sdk/types'

export const getAnalyticsCookiePermissions = () => {
  return {
    category: CookieCategory.Analytics,
  } satisfies CookieConsentPermissions
}

export const getMarketingCookiePermissions = () => {
  return {
    category: CookieCategory.Marketing,
  } satisfies CookieConsentPermissions
}

export const getCookieConsentCategory = (
  category: CookieConsentPermissions['category'],
  cookieConsent?: CookieConsent,
) => {
  if (!cookieConsent) {
    return true
  }

  return cookieConsent.permissions?.find(p => p.category === category)
}
